import {createCarousel} from "./create-carousel";

function alignRelatedCarouselButtons(root)
{
    if (!root) {
        return;
    }

    const prevButton = root.querySelector('.related-carousel__prev');
    const nextButton = root.querySelector('.related-carousel__next');
    if (!prevButton && !nextButton) {
        return;
    }

    const setTop = function() {
        const image = root.querySelector('.related-carousel__slide img');
        if (!image) {
            return;
        }
        const imageHeight = image.offsetHeight;
        if (!imageHeight) {
            return;
        }
        const arrowTop = (imageHeight / 2) + 'px';
        if (prevButton) {
            prevButton.style.top = arrowTop;
        }
        if (nextButton) {
            nextButton.style.top = arrowTop;
        }
    };

    root._alignRelatedCarouselButtons = setTop;
    setTop();

    const image = root.querySelector('.related-carousel__slide img');
    if (image && (!image.complete || image.naturalWidth === 0)) {
        image.addEventListener('load', setTop, {once: true});
        image.addEventListener('error', setTop, {once: true});
    }

    if (!root._relatedArrowResizeBound) {
        root._relatedArrowResizeBound = true;
        window.addEventListener('resize', setTop);
    }
}

function loadLazyImages(slide)
{
    if (!slide) {
        return;
    }
    slide.querySelectorAll('img.swiper-lazy[data-src], img.related-carousel__lazy[data-src]').forEach(function(img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.classList.remove('swiper-lazy', 'related-carousel__lazy', 'lazy');
        const parent = img.parentElement;
        if (parent) {
            const preloader = parent.querySelector('.swiper-lazy-preloader');
            if (preloader) {
                preloader.remove();
            }
        }
        const root = slide.closest('.related-carousel');
        const realign = function() {
            if (root && typeof root._alignRelatedCarouselButtons === 'function') {
                root._alignRelatedCarouselButtons();
            }
        };
        if (img.complete && img.naturalWidth > 0) {
            realign();
        } else {
            img.addEventListener('load', realign, {once: true});
            img.addEventListener('error', realign, {once: true});
        }
    });
}

function loadVisibleSlides(root)
{
    const slides = root.querySelectorAll('.related-carousel__slide');
    if (!slides.length) {
        return;
    }

    const viewport = root.querySelector('.related-carousel__viewport') || root;
    const viewportRect = viewport.getBoundingClientRect();
    const viewportReady = viewportRect.width > 0;

    slides.forEach(function(slide, index) {
        if (!viewportReady) {
            if (index < 5) {
                loadLazyImages(slide);
            }
            return;
        }
        const rect = slide.getBoundingClientRect();
        const visible = rect.left < viewportRect.right + 40 && rect.right > viewportRect.left - 40;
        if (visible) {
            loadLazyImages(slide);
        }
    });
}

function getSlidesPerPage()
{
    // Match CSS: 3 slides on mobile, 5 on desktop (max 5).
    return window.innerWidth < 768 ? 3 : 5;
}

/**
 * Loads the page that starts at `index`. On select the track has only just started its
 * transition, so the incoming slides are still outside the viewport: going by geometry
 * (loadVisibleSlides) would skip them.
 */
function loadSlidesFromIndex(root, index)
{
    const slides = root.querySelectorAll('.related-carousel__slide');
    const end = Math.min(slides.length, index + getSlidesPerPage());
    for (let i = Math.max(0, index); i < end; i++) {
        loadLazyImages(slides[i]);
    }
}

export function initWebHomeRelatedProductsCarousel(scope)
{
    if (!scope || !scope.querySelectorAll) {
        return;
    }

    const roots = [];
    if (scope.classList && scope.classList.contains('related-carousel')) {
        roots.push(scope);
    } else {
        scope.querySelectorAll('.related-carousel').forEach(function(root) {
            roots.push(root);
        });
    }

    roots.forEach(function(root) {
        if (!root || root.classList.contains('is-initialized')) {
            return;
        }

        if (!root.querySelectorAll('.related-carousel__slide').length) {
            return;
        }

        const api = createCarousel(root, {
            selectors: {
                viewport: '.related-carousel__viewport',
                track: '.related-carousel__track',
                slide: '.related-carousel__slide',
                prev: '.related-carousel__prev',
                next: '.related-carousel__next'
            },
            loop: false,
            mode: 'offset',
            slidesPerView: 1,
            slidesPerGroup: getSlidesPerPage,
            startIndex: 0,
            swipe: true,
            suppressClickOnSwipe: true,
            arrows: {mode: 'toggle-hidden'},
            watchResize: true,
            onInit: function() {
                loadVisibleSlides(root);
                alignRelatedCarouselButtons(root);
            },
            onSelect: function(index) {
                loadSlidesFromIndex(root, index);
                alignRelatedCarouselButtons(root);
            }
        });

        if (api) {
            loadVisibleSlides(root);
            alignRelatedCarouselButtons(root);
        }
    });
}
